var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn",class:{
                'btn-success': _vm.showEnableVariant,
                'btn-primary': !_vm.showEnableVariant,
                'spinner spinner-white spinner-sm spinner-left': _vm.formIsProcessing
            },attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.formIsProcessing),expression:"!formIsProcessing"}],staticClass:"fas fa-save"}),_vm._v("\n        "+_vm._s(_vm.buttonText)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }